{
  "schemaVersion": "1.0",
  "status": "DRAFT_DIRECTIONAL",
  "note": "Directional marketing content. Prices are management targets; public-pricing.json must be generated from Pricing Master at publish.",
  "moduleId": "intelligence",
  "roles": [
    "technician",
    "inspector",
    "director-of-maintenance",
    "planner",
    "parts-coordinator",
    "records-specialist"
  ],
  "orgTypes": [
    "part-91-owner",
    "corporate-flight-dept",
    "management-company",
    "part-135",
    "fractional",
    "part-145",
    "independent-mro",
    "mobile-aog",
    "oem-service",
    "component-shop",
    "operator-internal-mx",
    "integrated-135-145"
  ],
  "extensions": [
    "byom",
    "co-build",
    "ironfleet-network"
  ],
  "integrations": [
    "partsbase",
    "sharepoint"
  ]
}